import { ROLES } from '../../features/Permission'
import { TUserRolesFilterGroupedRoles } from './types'

export const ROLES_BY_GROUPS: TUserRolesFilterGroupedRoles = {
  health_system: {
    label: 'Health system',
    roles: [
      'community_sourcing_leader',
      ROLES.VICE_PRESIDENT,
      ROLES.CONTRACT_STEWARD,
      ROLES.LEGAL,
      ROLES.ANALYST,
      ROLES.COMMUNITY_RCA,
      ROLES.FINANCE,
      ROLES.CLINICAL_COORDINATOR
    ]
  },
  hospital: {
    label: 'Hospital',
    roles: [ROLES.HOSPITAL_ADMIN, ROLES.HOSPITAL_USER]
  },
  vendor: {
    label: 'Vendor',
    roles: [
      ROLES.VENDOR_CONTRACT_ADMIN,
      ROLES.VENDOR_LEGAL,
      ROLES.VENDOR_ANALYST,
      ROLES.SALES_REPRESENTATIVE,
      ROLES.VENDOR_CONTRACT_STEWARD,
      ROLES.VENDOR_FINANCE_OFFICER
    ]
  }
}
